export interface OrganMapCoordinates {
  positionX: unknown;
  positionY: unknown;
}

export type PositionedOrganMapMarker<T> = T & {
  positionX: number;
  positionY: number;
};

const normalizeCoordinate = (value: unknown): number | undefined => {
  if (typeof value !== "number" && typeof value !== "string") return undefined;
  if (typeof value === "string" && value.trim() === "") return undefined;

  const coordinate = Number(value);
  return Number.isFinite(coordinate) && coordinate >= 0 && coordinate <= 100
    ? coordinate
    : undefined;
};

export function partitionOrganMapMarkers<T extends OrganMapCoordinates>(
  markers: T[]
): { positioned: PositionedOrganMapMarker<T>[]; unpositioned: T[] } {
  const positioned: PositionedOrganMapMarker<T>[] = [];
  const unpositioned: T[] = [];

  markers.forEach((marker) => {
    const positionX = normalizeCoordinate(marker.positionX);
    const positionY = normalizeCoordinate(marker.positionY);
    if (positionX === undefined || positionY === undefined) {
      unpositioned.push(marker);
      return;
    }
    positioned.push({ ...marker, positionX, positionY });
  });

  return { positioned, unpositioned };
}
